<template>
  <div class="shortcut-cell-wrapper" @click="$emit('click')">
    <avatar class="profile-avatar" :backgroundColor="avatarBgColor" color="#000" size="48" :username="username" />
    <div class="name-wrapper">
      <div class="top-section" v-if="name.length">
        <div class="title-styling">{{ name }}</div>
      </div>
      <div class="subtitle-styling">{{ email }}</div>
      <div v-if="shareType.length" :style="getStyles(this.shareType)" class="shareType-Styling">
        {{ shareType }}
      </div>
      <div v-else-if="sharedResources.length" class="date-resources-wrapper">
        <div class="resource-cells-wrapper">
          <div v-for="resources of sharedResources" :key="resources.id">
            <div class="shareType-Styling" :style="getStyles(resources.resourceType)"
              @click="$emit('itemClick', resources.resourceType, parentIndex)">
              {{ getSharedResourceTitle(resources) }}
            </div>
          </div>
        </div>
        <div v-if="shareDate">{{ shareDate }}</div>
      </div>
    </div>
    <div @mouseover="hover = true" @mouseleave="hover = false" v-if="showDeleteIcon" class="delete-wrapper">
      <v-tooltip bottom light color="#000000" open-on-hover="true" open-on-click="false" open-on-focus="false"
        max-width="150">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" @click="$emit('btnClick')" class="fa-regular fa-trash-xmark" size="24"
            :style="styleButton" />
        </template>
        <span>Remove share</span>
      </v-tooltip>
    </div>

  </div>
</template>

<script>
import Avatar from 'vue-avatar'

export default {
  name: 'ShortcutCellWithAvatar',
  data() {
    return {
      hover: false
    }
  },
  components: {
    Avatar
  },
  props: {
    email: {
      type: String,
      default: ''
    },
    shareType: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    avatarBgColor: {
      type: String,
      default: '#bcddda'
    },
    showDeleteIcon: {
      type: Boolean,
      default: true
    },
    sharedResources: {
      type: Array,
      default: () => []
    },
    parentIndex: {
      type: [Number, String],
      default: -1
    },
    showAvatar: {
      type: Boolean,
      default: false
    },
    shareDate: {
      type: String,
      default: ''
    }
  },
  computed: {
    username() {
      let initials = this.name.split(' ')
      if (initials.length === 3) {
        // Checking if user has middle name as well
        initials.splice(1, 1) // Removing middle name
        return initials.join(' ') // Joing first and last name to show.
      }
      return this.name
    },
    styleButton() {
      return this.hover ? "color: #161616" : "color: #8E909A"
    }
  },
  methods: {
    getSharedResourceTitle(resource) {
      return resource.resourceType === '*'
        ? 'Full Profile'
        : resource.resourceType === 'cc'
          ? 'Cancer Summary'
          : resource.resourceType
    },
    getStyles(type) {
      return type === '*' || type === 'Full Profile'
        ? 'color: #194066; background: #EEF3F8;'
        : type === 'Document'
          ? 'color: #323336; background: #E5E6EE;'
          : 'color: #8E2666; background: #F6EDF3;'
    }
  }
}
</script>

<style scoped>
.shortcut-cell-wrapper {
  border: 1px solid #c9cbd5;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  display: flex;
  margin: 8px 0;
}

.shortcut-cell-wrapper:hover {
  background: #F9F9FA;
}

.top-section {
  display: flex;
  align-items: center;
}

.title-styling {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #161616;
  text-overflow: ellipsis;
  line-break: anywhere;
}

.subtitle-styling {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #565963;
  text-overflow: ellipsis;
  line-break: anywhere;
}

.shareType-Styling {
  border-radius: 22px;
  font-size: 14px;
  margin: 8px 8px 0 0;
  padding: 6px 16px;
  width: fit-content;
  font-weight: 700;
  font-style: normal;
  line-height: 18px;
  letter-spacing: 0.02em;
}

.profile-avatar {
  min-width: 48px;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin-right: 16px;
}

.name-wrapper {
  order: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-overflow: ellipsis;
  width: -webkit-fill-available;
}

.delete-wrapper {
  order: 2;
  align-self: flex-start;
  flex-grow: 0;
  display: flex;
  place-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 5px;
  background-color: transparent
}

.delete-btn {
  font-weight: 600;
  line-height: 24px;
  font-size: 20px;
}

.v-tooltip__content {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  padding: 2px 8px 3px 8px;
  border-radius: 5px;
}

.delete-wrapper:hover {
  background-color: #F1F1F7
}

.date-resources-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media only screen and (min-width: 370px) {
  .resource-cells-wrapper {
    display: flex;
    flex-wrap: wrap;
    -webkit-column-count: 2;
  }
}

@media only screen and (min-width: 500px) {
  .resource-cells-wrapper {
    display: flex;
    flex-wrap: wrap;
    -webkit-column-count: 3;
  }
}
</style>
